<template>
  <v-footer padless class="tech-footer">
    <div class="scanlines"></div>
    
    <div class="neon-top-border"></div>

    <v-container fluid class="py-0 content-relative">
      <v-row no-gutters align="center" justify="space-between" style="height: 60px;">
        
        <v-col cols="12" md="6" class="text-center text-md-left">
          <div class="d-flex align-center justify-center justify-md-start">
            <v-icon small color="cyan accent-3" class="mr-2 blink-slow">mdi-console-line</v-icon>
            <p class="mb-0 white--text mono-font text-caption">
              © {{ year }} <span class="cyan--text font-weight-bold">NIC.NI</span> // ALL_RIGHTS_RESERVED
            </p>
          </div>
        </v-col>

        <v-col cols="12" md="6" class="text-center text-md-right hidden-sm-and-down">
          <div class="d-flex align-center justify-end">
            <span class="grey--text text--darken-1 text-caption mono-font mr-4">SYS_VER: 2.0.45</span>
            <v-chip x-small color="rgba(0, 255, 0, 0.1)" class="green--text text--accent-3 border-green">
              <span class="status-dot mr-2"></span> SYSTEM ONLINE
            </v-chip>
          </div>
        </v-col>

      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    year: new Date().getFullYear() // Calculado reactivamente
  })
}
</script>

<style scoped>
/* --- ESTÉTICA CYBERPUNK --- */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&display=swap');

.tech-footer {
  background-color: #050a14 !important; /* Negro azulado profundo */
  position: relative;
  overflow: hidden;
  z-index: 10;
  border-top: 1px solid rgba(0, 229, 255, 0.1);
}

.mono-font {
  font-family: 'Fira Code', monospace !important;
  letter-spacing: 1px;
}

/* Línea de Neón Superior */
.neon-top-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #00e5ff 50%, transparent 100%);
  box-shadow: 0 0 10px #00e5ff;
  opacity: 0.7;
}

/* Scanlines */
.scanlines {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0) 50%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.3));
  background-size: 100% 4px;
  pointer-events: none;
  z-index: 1;
}

.content-relative {
  position: relative;
  z-index: 2;
}

/* Utilidades */
.border-green {
  border: 1px solid #00e676 !important;
}

/* Animaciones */
.status-dot {
  width: 6px;
  height: 6px;
  background-color: #00e676;
  border-radius: 50%;
  box-shadow: 0 0 5px #00e676;
  display: inline-block;
  animation: pulse 2s infinite;
}

.blink-slow {
  animation: blink 4s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

@keyframes blink {
  0%, 90%, 100% { opacity: 1; }
  95% { opacity: 0; }
}
</style>